export const namespacedPrefix = '[DISHES]';
